module.exports = __webpack_public_path__ + "logo.png?c4d917ffa971f0f8a725131580741e99";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logo.png
// module id = 845
// module chunks = 0